import React from 'react';
import Header from '../components/Header';
import { FocusCards } from '../components/ui/focus-cards';

const CaseStudiesListing = () => {
  const caseStudies = [
    {
      title: "Shivender Kanwar - Ex Para SF",
      src: "https://framerusercontent.com/images/JzcWDujEppYhyBZCJpLK0z76Y0k.jpeg?width=1280&height=960",
      slug: "shivender-kanwar"
    }
  ];

  return (
    <div className="min-h-screen bg-black text-white">
      <Header />

      {/* Case Studies Section */}
      <section className="pt-32 pb-24 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-5xl sm:text-6xl md:text-7xl font-bold mb-4 text-center" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
            Case Studies
          </h1>
          <p className="text-xl text-white/70 mb-16 text-center max-w-3xl mx-auto" style={{ fontFamily: 'Inter, sans-serif' }}>
            Real results from real clients. See how we've helped brands grow through video-led content strategies.
          </p>

          {/* Case Study Card */}
          <FocusCards cards={caseStudies} />
        </div>
      </section>

      {/* Footer */}
      <footer className="relative py-16 sm:py-24 border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <img 
                  src="https://framerusercontent.com/images/mCmSpcpcYCZJTSJSoearkxxG0FQ.png?width=236&height=240" 
                  alt="AttentionLabs" 
                  className="h-10 w-10"
                />
                <span className="text-white font-bold text-xl" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                  AttentionLabs
                </span>
              </div>
              <p className="text-white/70 text-sm mb-4" style={{ fontFamily: 'Inter, sans-serif' }}>
                811, Tower C, Unitech Business Zone<br />
                Sector 50, Gurugram, India
              </p>
            </div>

            <div>
              <h3 className="font-semibold mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>Links</h3>
              <ul className="space-y-2 text-sm">
                <li><a href="/#clients" className="text-white/70 hover:text-white transition-colors" style={{ fontFamily: 'Inter, sans-serif' }}>Clients</a></li>
                <li><a href="/#portfolio" className="text-white/70 hover:text-white transition-colors" style={{ fontFamily: 'Inter, sans-serif' }}>Portfolio</a></li>
                <li><a href="/#why-choose-us" className="text-white/70 hover:text-white transition-colors" style={{ fontFamily: 'Inter, sans-serif' }}>Why Choose Us</a></li>
                <li><a href="/#testimonials" className="text-white/70 hover:text-white transition-colors" style={{ fontFamily: 'Inter, sans-serif' }}>Testimonials</a></li>
              </ul>
            </div>

            <div>
              <h3 className="font-semibold mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>Pages</h3>
              <ul className="space-y-2 text-sm">
                <li><a href="/" className="text-white/70 hover:text-white transition-colors" style={{ fontFamily: 'Inter, sans-serif' }}>Home</a></li>
                <li><a href="/portfolio" className="text-white/70 hover:text-white transition-colors" style={{ fontFamily: 'Inter, sans-serif' }}>Portfolio</a></li>
                <li><a href="/casestudies" className="text-white/70 hover:text-white transition-colors" style={{ fontFamily: 'Inter, sans-serif' }}>Case Studies</a></li>
                <li><a href="/contact" className="text-white/70 hover:text-white transition-colors" style={{ fontFamily: 'Inter, sans-serif' }}>Contact</a></li>
              </ul>
            </div>

            <div>
              <h3 className="font-semibold mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>Socials</h3>
              <ul className="space-y-2 text-sm">
                <li><a href="https://www.instagram.com/attention.labs/" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-colors" style={{ fontFamily: 'Inter, sans-serif' }}>Instagram</a></li>
                <li><a href="https://www.youtube.com/@AttentionLabs-br" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-colors" style={{ fontFamily: 'Inter, sans-serif' }}>YouTube</a></li>
                <li><a href="https://www.linkedin.com/company/attentionlabscom/" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-colors" style={{ fontFamily: 'Inter, sans-serif' }}>LinkedIn</a></li>
              </ul>
            </div>
          </div>

          <div className="border-t border-white/10 pt-8 text-center">
            <p className="text-white/50 text-sm" style={{ fontFamily: 'Inter, sans-serif' }}>
              Visioned and Crafted by AttentionLabs © All rights reserved
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default CaseStudiesListing;
